var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTable = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M1.5 1.5C0.671573 1.5 0 2.17157 0 3V21C0 21.8284 0.671573 22.5 1.5 22.5H22.5C23.3284 22.5 24 21.8284 24 21V3C24 2.17157 23.3284 1.5 22.5 1.5H1.5ZM1.5 3V21H22.5V3H1.5ZM10.5 9H7.5V7.5H10.5V9ZM4.5 7.5H6V9H4.5V7.5ZM3 9V10.5V12V13.5V15V16.5V18V19.5H4.5H6H7.5H10.5H12H15H16.5H19.5H21V18V16.5V15V13.5V12V10.5V9V7.5V6V4.5H3V6V7.5V9ZM16.5 18H19.5V16.5H16.5V18ZM16.5 15H19.5V13.5H16.5V15ZM15 13.5V15H12V13.5H15ZM16.5 12H19.5V10.5H16.5V12ZM15 10.5V12H12V10.5H15ZM16.5 9H19.5V7.5H16.5V9ZM15 7.5V9H12V7.5H15ZM15 16.5V18H12V16.5H15ZM4.5 15V13.5H6V15H4.5ZM4.5 12H6V10.5H4.5V12ZM7.5 15V13.5H10.5V15H7.5ZM7.5 12H10.5V10.5H7.5V12ZM7.5 16.5H10.5V18H7.5V16.5ZM4.5 16.5H6V18H4.5V16.5Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTable);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/table.a7533616dcfbe71586e4513c5f0d014b.svg";